import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";

import {
  buildAdviseePersonalInfoUri,
  buildAdviseePoliciesUri,
  buildAdviseeCashFlowUri,
  buildAdviseeEstatePlanningUri,
  buildAdviseeInvestmentPortfolioUri,
  buildAdviseeNavReprogramUri,
  buildAdviseeActionPlanUri,
  buildAdviseeFutureReviewUri,
  buildPPISummaryUri,
  buildPPSSummaryUri,
  buildPCFSummaryUri,
  buildPEPSummaryUri,
  buildPIPSummaryUri,
  buildPNRSummaryUri,
  buildPAPSummaryUri,
  buildPFRSummaryUri,
} from "utils/routes";

import IconAdviseeDetails from "./icons/AdviseeDetails.svg";
import IconAdviseePolicies from "./icons/AdviseePolicies.svg";
import IconAdviseeCashFlow from "./icons/AdviseeCashFlow.svg";
import IconAdviseeEstatePlanning from "./icons/AdviseeEstatePlanning.svg";
import IconAdviseeInvestmentPortfolio from "./icons/AdviseeInvestmentPortfolio.svg";
import IconAdviseeNavReprogram from "./icons/AdviseeNavReprogram.svg";
import IconAdviseeFutureReview from "./icons/AdviseeFutureReview.svg";

import { withAppContext } from "contexts/AppContext/AppContext";

import {
  SubMenuItem,
  SubMenuItemContainer,
  SubMenuItemIcon,
} from "./SubMenuNavBar.styles";

const SubMenuNavBar = ({
  isAdmin,
  isFree,
  isAgentEntry,
  isAgentFull,
  isLeader,
  isContributor,
}) => {
  const history = useHistory();
  const { id } = useParams();
  const currentLocation = useLocation().pathname;

  const subMenuItems = [
    {
      icon: IconAdviseeDetails,
      label: "Advisee Personal Details",
      isActive: currentLocation.startsWith(buildAdviseePersonalInfoUri(id)),
      onClick: () => history.push(buildPPISummaryUri(id)),
    },
    {
      icon: IconAdviseePolicies,
      label: "Advisee Owned Policies",
      isActive: currentLocation.startsWith(buildAdviseePoliciesUri(id)),
      onClick: () => history.push(buildPPSSummaryUri(id)),
    },
    {
      icon: IconAdviseeCashFlow,
      label: "Advisee Cash Flow Management",
      isActive: currentLocation.startsWith(buildAdviseeCashFlowUri(id)),
      onClick: () => history.push(buildPCFSummaryUri(id)),
    },

    ...(!isFree
      ? [
          {
            icon: IconAdviseeEstatePlanning,
            label: "Advisee Estate Planning",
            isActive: currentLocation.startsWith(
              buildAdviseeEstatePlanningUri(id)
            ),
            onClick: () => history.push(buildPEPSummaryUri(id)),
          },
        ]
      : []),

    ...(!isFree
      ? [
          {
            icon: IconAdviseeInvestmentPortfolio,
            label: "Investment Portfolio",
            isActive: currentLocation.startsWith(
              buildAdviseeInvestmentPortfolioUri(id)
            ),
            onClick: () => history.push(buildPIPSummaryUri(id)),
          },
        ]
      : []),

    {
      icon: IconAdviseeNavReprogram,
      label: "Nav Reprogram",
      isActive: currentLocation.startsWith(buildAdviseeNavReprogramUri(id)),
      onClick: () => history.push(buildPNRSummaryUri(id)),
    },
    {
      icon: <EditOutlined style={{ fontSize: 24, color: "white" }} />,
      isIcon: true,
      label: "Action Plan",
      isActive: currentLocation.startsWith(buildAdviseeActionPlanUri(id)),
      onClick: () => history.push(buildPAPSummaryUri(id)),
    },
    {
      icon: IconAdviseeFutureReview,
      label: "Future Review",
      isActive: currentLocation.startsWith(buildAdviseeFutureReviewUri(id)),
      onClick: () => history.push(buildPFRSummaryUri(id)),
    },
  ];

  return subMenuItems.map((subMenuItem) => (
    <SubMenuItem justify="center" align="middle" key={subMenuItem.label}>
      <SubMenuItemContainer
        isActive={subMenuItem.isActive}
        onClick={subMenuItem.onClick}
      >
        {subMenuItem.isIcon ? (
          subMenuItem.icon
        ) : (
          <SubMenuItemIcon
            src={subMenuItem.icon}
            width="32px"
            height="32px"
            alt={`${subMenuItem.label} Icon`}
          />
        )}
      </SubMenuItemContainer>
    </SubMenuItem>
  ));
};

export default withAppContext(SubMenuNavBar);
